import '../bootstrap'
import 'jquery-ui/ui/widgets/datepicker.js';
import validate from 'jquery-validation/dist/jquery.validate';
import { Iodine } from '@kingshott/iodine';
import "../../vendor/summernote/summernote-lite";
window.validate = validate;

// Packages
window.Cropper = require('cropperjs');

window.carousel = require('owl.carousel');

window.toastr = require('toastr');
window.toastr.options = {
    preventDuplicates: true,
    preventOpenDuplicates: true,
    closeButton: true,
    positionClass: 'toast-top-center'
};

window.heic2any = require('heic2any');

window.iodine = new Iodine();

import intlTelInput from 'intl-tel-input/build/js/intlTelInput.min';
window.intlTelInput = intlTelInput;

import countdownTimer from './CountdownTimer';
window.countdownTimer = countdownTimer;

require('./_custom')
require('./_iodine')
